<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-card class="rounded-xl" flat>
        <v-card-title class="justify-center">{{
          $t("dsFunctionType.title")
        }}</v-card-title>
        <v-card-text>
          <div class="rowinfo">
            <v-select
              v-model="computedValue.name"
              :items="translatedItems"
              :menu-props="{ offsetY: true }"
              class="rounded-lg contentinfo"
              dense
              hide-details
              outlined
            />
            <help-info
              :element-name="`${serviceName}-${componentName}-computedValue-name`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              :label="$t('dsFunctionType.labels.applyDiscount')"
            />
          </div>
        </v-card-text>

        <template v-if="computedValue.name === 'SpecialProducts'">
          <v-card-title class="justify-center">{{
            $t("dsFunctionType.productListTitle")
          }}</v-card-title>
          <v-card-text>
            <personal-product-picker
              v-model="computedValue.SpecialProducts"
              @submit="submitProducts"
            />
          </v-card-text>
        </template>

        <template v-if="computedValue.name === 'SpecialCategories'">
          <v-card-title class="justify-center">{{
            $t("dsFunctionType.categoryListTitle")
          }}</v-card-title>
          <v-card-text>
            <personal-category-picker
              :value="computedValue.SpecialCategories"
              :label="$t('dsFunctionType.labels.category')"
              multiple
              @input="submitCategories"
            />
          </v-card-text>
        </template>
      </v-card>
    </template>
  </help-info-wrapper>
</template>

<script>
import PersonalProductPicker from "@/view/components/pickers/personalProductPicker.vue";
import PersonalCategoryPicker from "@/view/components/pickers/personalCategoryPicker.vue";

export default {
  name: "dsFunctionType",

  components: { PersonalCategoryPicker, PersonalProductPicker },

  props: {
    value: Object,
  },

  data: () => ({
    helpData: [],
    componentName: "cardVisit",
    serviceName: "Qrland",
  }),
  watch: {
    "$i18n.locale": {
      handler() {
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    translatedItems() {
      return [
        {
          value: "AllShoppingCart",
          text: this.$t("dsFunctionType.items.AllShoppingCart"),
        },
        {
          value: "SpecialProducts",
          text: this.$t("dsFunctionType.items.SpecialProducts"),
        },
        {
          value: "SpecialCategories",
          text: this.$t("dsFunctionType.items.SpecialCategories"),
        },
      ];
    },
  },

  methods: {
    submitProducts(list) {
      this.computedValue.SpecialProducts = list.map((item) => item.id);
      delete this.computedValue.SpecialCategories;
    },
    submitCategories(list) {
      this.computedValue.SpecialCategories = list;
      delete this.computedValue.SpecialProducts;
    },
  },
};
</script>

<style scoped></style>
